import React, {Component} from "react";
import CmModal from "../../../../../components/CmModal/CmModal";
import CmForm from "../../../../../components/CmForm/CmForm";
import {Form, Input} from "antd";
import {message} from "../../../utils/sysManagementUtils";
import PermissionTreeSelect from "../permissionTreeSelect/PermissionTreeSelect";
import {validateName} from "../../../../../utils";

export default class PermissionTreeEditModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editData: null
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.visible&&this.props.visible !== prevProps.visible) {
            this.setState({
                editData: initData(this.props.data || {})
            });
        }
    }

    render() {
        const {
            visible
        } = this.props;

        const {editData} = this.state;

        if (!editData) {
            return null;
        }
        const isCreate = !editData.id.value;
        const onDataChange = this.onDataChange;

        return (
            <CmModal
                visible={visible}
                handleCancel={this.handleCancel}
                handleOk={this.handleOk}
                title={isCreate ? "添加分类" : "修改分类"}
            >
                <CmForm>
                    <Form.Item
                        label={editData.fid.label}
                        required={editData.fid.required}
                    >
                        <PermissionTreeSelect
                            value={editData.fid.value}
                            currentId={editData.id.value}
                            handleOk={fid => onDataChange({fid})}
                            checkStrictly={true}
                            onItemDelete={id => onDataChange({fid: ""})}
                            placeholder={editData.fid.placeholder}
                        />
                    </Form.Item>
                    <Form.Item
                        label={editData.name.label}
                        required={editData.name.required}
                    >
                        <Input
                            value={editData.name.value}
                            onChange={e => onDataChange({name: e.target.value})}
                            placeholder={editData.name.placeholder}
                        />
                    </Form.Item>
                </CmForm>
            </CmModal>
        );
    }

    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };

    handleOk = () => {
        const {editData} = this.state;
        const data = {};
        const editDataKeys = Object.keys(editData);
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            if (editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        this.props.handleOk(data);
    };

    handleCancel = () => {
        this.props.handleCancel();
    };

}

function initData(
    {
        fid = "",
        name = "",
        sort = 0,
        id = ""
    } = {}
) {
    return {
        id: {
            value: id
        },
        fid: {
            value: fid,
            required: true,
            label: "上级分类",
            placeholder: "请选择上级分类",
            check: value => {
                let check = true;
                if (!value) {
                    check = false;
                    message.error("请选择上级分类！");
                }
                return check;
            }
        },
        name: {
            value: name,
            required: true,
            label: "分类名称",
            placeholder: "请输入分类名称",
            check: value => {
                if (!value) {
                    message.error("权限名称不能为空！");
                    return false;
                }
                if(!validateName(value,{min:1,max:50})){
                    message.error("权限名称长度在1-50之间！")
                    return false
                }
                return true;
            }
        },
        belongModule: {
            value: "belongModule",
            required: false,
            label: "所属模块",
            placeholder: "所属模块"
        },
        sort: {
            value: sort,
            required: false,
            label: "排序",
            placeholder: "请输入排序"
        }
    };
}

